import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { InputField, HoverButton, Newlogo, Text } from "../../components";
import Icons from "../../assets/icon/index";
import Functions from "./index.function";
import { fontSizes } from "../../constants/constants";
const ChangePassword = () => {
  const {
    handleSubmit,
    onSubmit,
    control,
    errors,
    register,
    setValue,
    getValues,
    loadingToapi,
    TextWeight
  } = Functions();
  return (
    <div className="bg-primary scroll-container h-screen">
      <div className="lg:py-10 max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center relative xs:pt-5">
          <Newlogo />
        </div>
      </div>
      <div className="max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center flex-col relative lg:pb-8">
          <h1 className="uppercase text-secondary font-unboundedBold lg:text-3xl lg:leading-tight">
            Change Password
          </h1>
        </div>
        <form
          className="flex justify-center items-center flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="relative mt-4 xs:w-full sm:w-[90%] lg:w-[70%]">
            <InputField
              control={control}
              errors={errors}
              label="Current Password"
              type="password"
              name="current_password"
              isPassword={true}
              iconPasswordVisible={Icons.showPasswordIcon}
              iconPasswordHidden={Icons.hidePasswordIcon}
              iconStyle={"xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-6 w-7 3xl:w-8 3xl:h-7"}
              {...register("current_password", {
                required: "Current Password is required",
                pattern: {
                  value: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
                  // message:
                  //   "Current Password must be at least 8 characters long, contain at least 1 uppercase letter and 1 number",
                },
              })}
              onChange={(value) => setValue("current_password", value)}
            />
          </div>
          <div className="relative mt-4 xs:w-full sm:w-[90%] lg:w-[70%]">
            <InputField
              control={control}
              errors={errors}
              label="New Password"
              type="password"
              name="password"
              isPassword={true}
              iconPasswordVisible={Icons.showPasswordIcon}
              iconPasswordHidden={Icons.hidePasswordIcon}
              iconStyle={"xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-6 w-7 3xl:w-8 3xl:h-7"}
              {...register("password", {
                required: "New Password is required",
                pattern: {
                  value: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
                  // message:
                  //   "New Password must be at least 8 characters long, contain at least 1 uppercase letter and 1 number",
                },
              })}
              onChange={(value) => setValue("password", value)}
            />
          </div>
          <div className="relative mt-4 xs:w-full sm:w-[90%] lg:w-[70%]">
            <InputField
              control={control}
              errors={errors}
              label="Confirm Password"
              type="password"
              name="confirmPassword"
              isPassword={true}
              iconPasswordVisible={Icons.showPasswordIcon}
              iconPasswordHidden={Icons.hidePasswordIcon}
              iconStyle={"xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-6 w-7 3xl:w-8 3xl:h-7"}
              {...register("confirmPassword", {
                required: "Confirm Password is required",
                validate: (value) =>
                  value === getValues("password") || "Passwords do not match",
              })}
              onChange={(value) => setValue("confirmPassword", value)}
            />
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] pl-6 sm:pl-6 lg:pl-8"
            }
          >
            <Text
              text="Password must be at least 8 characters long, contain at least 1 uppercase letter and 1 number"
              size={fontSizes.h14}
              color="text-secondary"
              align="text-left"
              weight={TextWeight.Onest_regular}
              isTruncate={false}
            />
          </div>
          <div className="flex justify-center flex-col items-center my-10 lg:my-8">
            <HoverButton
              extraClasses={`group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform ${loadingToapi ? "" : "hover:scale-105 hover:shadow-md"
                }`}
              BtnTitle={
                loadingToapi ? (
                  <div className="flex justify-center items-center">
                    <div
                      className={`animate-spin rounded-full border-t-2 border-b-2 border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8`}
                    ></div>
                  </div>
                ) : (
                  "Submit"
                )
              }
              disabled={loadingToapi}
              type={"submit"}
              BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${loadingToapi
                ? ""
                : "group-hover:scale-110 group-hover:text-primary"
                }`}
            />
          </div>
        </form>
      </div>
    </div>
  );
};
export default ChangePassword;
